import React from 'react';
import Styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Instructor, ProgramCategory } from '@gql/generated';
import InstructorsModal from '@organisms/modals/InstructorsModal';
import { Box, Flex } from '@components/layout/Grid';
import InstructorCircle from './instructorCircle';
import { ProgramInstructorsFragment } from '@gql/generated';

const OtherInstructors = Styled.p`
  font-weight: 600;
  margin-left: -5px;
`;

const Button = Styled.button<{ appearance?: ProgramCategory }>`
  color: ${({ theme, appearance }) =>
    appearance === ProgramCategory['Challenges']
      ? theme.colors.primary['green']
      : theme.colors.primary['blue-2']};
  font-weight: inherit;
  border: none;
  background: none;
  cursor: pointer;
`;

declare type Props = {
  programTitle: string;
  instructors: ProgramInstructorsFragment[];
  programCategory?: ProgramCategory;
};

const ProgramExpandableInstructors = ({
  programTitle,
  instructors,
  programCategory,
}: Props) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [instructor, ...otherInstructors] = instructors || [];

  return (
    <Flex
      className="whitespace-nowrap"
      mx="-5px"
      flexWrap="no-wrap"
      alignItems="center"
    >
      {instructor ? (
        <Box>
          <InstructorCircle instructor={instructor} />
        </Box>
      ) : null}
      {otherInstructors?.length > 0 ? (
        <>
          <OtherInstructors>
            &
            <Button
              appearance={programCategory}
              onClick={() => {
                setOpenModal(true);
              }}
            >
              <Trans
                id="programs_2021.programs.other_instructors_count"
                values={{ number: otherInstructors?.length }}
              />
            </Button>
          </OtherInstructors>
          <InstructorsModal
            title={
              <Trans
                id="programs_2021.programs.instructors_modal_title"
                values={{ program: programTitle }}
              />
            }
            open={openModal}
            instructors={instructors as Instructor[]}
            onClose={() => setOpenModal(false)}
          />
        </>
      ) : null}
    </Flex>
  );
};

export default ProgramExpandableInstructors;
